import PlaybackBaseLoader from "components/shared/PlaybackBaseLoader/PlaybackBaseLoader";

(function() {
  const cfg = window.__playbackConfig;

  PlaybackBaseLoader.configure({
    baseUrl: cfg.baseUrl,
    canaryBaseUrl: cfg.canaryBaseUrl,
    enableCustomSkipAdButtonToggle: cfg.enableCustomSkipAdButton,
    enablePremierUserBannerAdsToggle: cfg.enablePremierUserBannerAds,
    enableChaptersCreditTime: cfg.enableChaptersCreditTime,
    enablePrerollOnIOS: cfg.enablePrerollOnIOS,
    adsTvcSeekToLatest: cfg.adsTvcSeekToLatest,
    enableAdaptivePlayerLite: cfg.enableAdaptivePlayerLite,
    enableSubtitleFromMasterPlaylist: cfg.enableSubtitleFromMasterPlaylist
  });
})();
